
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 16\" id=\"expand\" ><defs/><title>expand</title><g id=\"expand_Layer_2\" data-name=\"Layer 2\"><g id=\"expand_Icons\"><g id=\"expand_expand\"><path class=\"cls-1\" d=\"M5 0H0v5h1.76V1.76H5V0zM11 0h5v5h-1.76V1.76H11V0zM11 16h5v-5h-1.77l.01 3.24H11V16zM5 5h6v6H5zM0 11v5h5v-1.76H1.76V11H0z\"/></g></g></g></symbol>";
module.exports = sprite.add(image, "expand");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/expand.svg
// module id = 651
// module chunks = 1474